<template>
  <aha-button class="present-button" size="sm" @click="handlePresentNowButtonClick">
    <aha-icon
      v-if="!isCheckingPerm"
      name="play"
      width="10"
      height="10"
      viewBox="0 0 24 24"
    />
    <aha-spinner variant="white" v-else />
    <span class="ml-1">{{ $i18nPresenter.t("Present") }}</span>
  </aha-button>
</template>

<script>

export default {
  props: {
    presentation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isCheckingPerm: false,
    }
  },
  methods: {
    async handlePresentNowButtonClick() {
      this.$emit('present', this.presentation)
    },
  },
}
</script>
